import { Col, Utils } from '@microfrontends/react-components'
import styled from 'styled-components'

export const ContactContainer = styled.div`
	padding: 32px 0;
	background: #006fed;
	color: #fff;
	overflow: hidden;
	strong {
		color: #fff;
	}
`

export const SocialContact = styled.div`
	margin-bottom:10px;
	img {
		display: inline-block;
		width: 61px;
	}
`

export const Link = styled.a`
	color: #fff;
`

export const BreakLine = styled.br`
	@media screen and (max-width: 1024px) {
		display: none;
	}
`

export const ContactSection = styled.div`
	@media screen and (max-width: ${Utils.screens.mobile}px) {
		margin-top: 60px;
	}
`


export const ContactWrapper = styled.div`
	color: #001644;
	display: grid;
	grid-template-rows: auto auto;
	grid-template-columns: auto;
	padding: 20px 0;
	
	@media all and (min-width: 992px) {
		grid-template-rows: auto;
		grid-template-columns: 1fr 1fr;
	}
	
	.contact {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 45px;
		> img {
			margin-left: auto;
		}
		.social-icons {
			display: flex;
		}
		.contact-info {
			img {
				width: 61px;
			}
		}
	}
`
